<template>
  <article :class="classList">
    <div class="card__inner">
      <header class="card__header">
        <div>
          <span>{{ headline }}</span>
          <UiHeadline
            tag="h3"
            :theme="variant === 'current' ? 'white' : 'primary'"
            >{{ title }}</UiHeadline
          >
        </div>
        <img
          v-if="image"
          :src="image.src"
          :alt="image.alt ? image.alt : ''"
          :width="image.width"
          :height="image.height"
        />
      </header>
      <div class="card__content">
        <ul class="list list--benefits">
          <li
            v-for="(benefit, index) in benefits"
            :key="index"
            v-html="benefit"
          ></li>
        </ul>
        <UiButton
          v-bind="{
            theme: button.theme,
            variant: button.variant,
            size: button.size,
          }"
          @click.native="select()"
        >
          {{ button.label }}
        </UiButton>
      </div>
    </div>
    <footer class="card__footer">
      <slot name="footer" />
    </footer>
  </article>
</template>
<script>
import UiHeadline from "./Ui/Headline.vue";
import UiButton from "./Ui/Button/index.vue";
export default {
  name: "Card",
  components: {
    UiHeadline,
    UiButton,
  },
  props: {
    variant: {
      type: String,
      default: null,
    },
    headline: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    image: {
      type: Object,
      default() {},
    },
    benefits: {
      type: Array,
      required: true,
    },
    button: {
      type: Object,
      default() {
        return {
          theme: "primary",
          variant: null,
          label: null,
        };
      },
    },
    isRecommended: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classList() {
      return {
        card: true,
        [`card--${this.variant}`]: this.variant,
        [`card--recommended`]: this.isRecommended,
      };
    },
  },

  methods: {
    select() {
      this.$emit("select");
    },
  },
};
</script>
